import { Controller } from '@hotwired/stimulus'

export default class FileInputFeedbackController extends Controller {
  static targets = ['name', 'input', 'placeholder'];

  connect() {
    if (this.inputTarget.files[0]) this.showFileNameAndFilledIcon();
  }

  showFileNameAndFilledIcon(_event) {
    if (this.hasPlaceholderTarget) { this.placeholderTarget.classList.add('d-none'); }
    this.nameTarget.textContent = this.inputTarget.files[0].name;
    this.nameTarget.classList.add('mb-2')
  }
}
